export default __webpack_public_path__ + "892d51aa51444bea587b5005bf7ec454.svg";